var map = {
	"./acme/logo.png": 3398,
	"./adaptdx/logo.png": 14130,
	"./augmedics/logo.png": 39262,
	"./clearsky/logo.png": 29738,
	"./cme/logo.png": 96037,
	"./default/logo.png": 75591,
	"./fort/logo.png": 80841,
	"./iec/logo.png": 13845,
	"./leica/logo.png": 14648,
	"./lkc/logo.png": 77868,
	"./lps/logo.png": 39895,
	"./macuhealth/logo.png": 50108,
	"./maculogix/logo.png": 10615,
	"./nanostring/logo.png": 66715,
	"./neurolens/logo.png": 94821,
	"./oxos/logo.png": 70929,
	"./sheapak/logo.png": 81933,
	"./topcon/logo.png": 27965,
	"./trice_medical/logo.png": 57371,
	"./viizr/logo.png": 38650,
	"./wellcomemat/logo.png": 68472
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 43234;